import { fn } from '@ember/helper';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import BvAccordion from 'volta/components/bv-accordion';
import BvIcon from 'volta/components/bv-icon';
import BvText from 'volta/components/bv-text';
import tElse from 'volta/helpers/t-else';

import type { TOC } from '@ember/component/template-only';

interface CollectionViewSettingsSectionSignature {
  Args: {
    onToggle: (section: string, isOpen: boolean) => void;
    section: string;
    settingsSection: string;
    title?: string;
    updated?: boolean;
  };
  Blocks: {
    default: [];
  };
}

const CollectionViewSettingsSectionComponent: TOC<CollectionViewSettingsSectionSignature> =
  <template>
    <BvAccordion
      @forceState={{if (eq @settingsSection @section) 'open' 'closed'}}
      @onToggle={{fn @onToggle @section}}
      @arrowDisplay='right'
      @triggerClassName='u-d-flex u-align-items-center u-px-4 u-py-3 u-bg-surface'
      @childClassName='u-p-4'
      @id={{@section}}
    >
      <:trigger>
        <div class='u-d-flex u-align-items-center'>
          <BvText @variant='heading-sm' @text={{tElse @title (t @section)}} />
          {{#if @updated}}
            <BvIcon
              @glyph='edit'
              @color='severe'
              @size='xs'
              @hasBackdrop={{true}}
              class='u-ml-2'
              data-test-is-edited-icon={{@section}}
            />
          {{/if}}
        </div>
      </:trigger>
      <:content>
        {{yield}}
      </:content>
    </BvAccordion>
  </template>;

export default CollectionViewSettingsSectionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CollectionView::Settings::Section': typeof CollectionViewSettingsSectionComponent;
    'collection-view/settings/section': typeof CollectionViewSettingsSectionComponent;
  }
}
